// eslint-disable-next-line no-restricted-imports
import { SavedSearchModel } from 'app/gamma/src/types/models';
// eslint-disable-next-line no-restricted-imports
import { SavedSearchResponse } from 'app/gamma/src/types/responses';
import genericNormalizer from './generic';

// eslint-disable-next-line @trello/no-module-logic
export const normalizeSavedSearch = genericNormalizer<
  SavedSearchResponse,
  SavedSearchModel
>(({ from }) => ({
  id: from('id'),
  name: from('name'),
  pos: from('pos'),
  query: from('query'),
}));
